import { useEffect } from 'react';
import useStore from '../rootStore.ts';

export function useAppAccountWatcher() {
  // Keyed on state, not an account-id change: a re-sign after resetToWalletConnected gets back the same id.
  useEffect(() => {
    return useStore.subscribe(
      (state) => state.status === 'AUTHENTICATED' && state.walletSnapshotReceived && state.account != null,
      (ready) => {
        if (ready) {
          useStore.getState().authorize();
        }
      },
      { fireImmediately: true }
    );
  }, []);
}
